import { render, staticRenderFns } from "./QuestionAndAnswer.vue?vue&type=template&id=7c1c948b&scoped=true"
import script from "./QuestionAndAnswer.vue?vue&type=script&lang=js"
export * from "./QuestionAndAnswer.vue?vue&type=script&lang=js"
import style0 from "./QuestionAndAnswer.vue?vue&type=style&index=0&id=7c1c948b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1c948b",
  null
  
)

export default component.exports